package com.bikompanion.ui.analytics

import com.bikompanion.domain.analytics.AnalyticsEvent

/**
 * What the rider did on screen. Domain outcomes, such as a vote or a watch, are recorded by their
 * use cases in [com.bikompanion.domain.analytics.DomainAnalyticsEvents] instead.
 */
object AnalyticsEvents {
    fun screenView(screenName: String) =
        AnalyticsEvent(
            name = "screen_view",
            parameters = mapOf("screen_name" to screenName, "screen_class" to screenName),
        )

    fun settingChanged(
        setting: String,
        value: String,
    ) = AnalyticsEvent(
        name = "setting_changed",
        parameters = mapOf("setting" to setting, "value" to value),
    )

    /** Every station sheet opened, whatever opened it. Links and notifications also report their own event. */
    fun stationSelected() = AnalyticsEvent("select_content", mapOf("content_type" to "station"))

    fun stationLinkOpened() = AnalyticsEvent("station_link_opened")

    fun stationNotificationOpened() = AnalyticsEvent("station_notification_opened")
}
